import React, { useCallback, useMemo, useState } from 'react';
import DateRangePicker from '../../../../shared/components/date-range-picker/DateRangePicker';
import { useTranslation } from 'react-i18next';
import { subDays, subYears, differenceInDays } from 'date-fns';
import './ComparisonDateRangePicker.scss';

type ComparisonPeriodType = 
  | 'PREVIOUS_PERIOD' 
  // | 'MONTH_BEFORE' 
  // | '2_MONTHS_BEFORE' 
  // | '3_MONTHS_BEFORE' 
  // | '6_MONTHS_BEFORE' 
  // | 'YEAR_BEFORE' 
  | 'CUSTOM';

interface ComparisonDateRangePickerProps {
  value: (Date | null)[] | null;
  onChange: (range: Date[]) => void;
  referenceStartDate: Date | null;
  referenceEndDate: Date | null;
  minDate?: Date;
  maxDate?: Date;
}

const ComparisonDateRangePicker: React.FC<ComparisonDateRangePickerProps> = ({
  value,
  onChange,
  referenceStartDate,
  referenceEndDate,
  minDate,
  maxDate,
}) => {
  const { t } = useTranslation();
  const [selectedPeriod, setSelectedPeriod] = useState<ComparisonPeriodType>('PREVIOUS_PERIOD');

  const comparisonPeriodOptions = useMemo(() => [
    { label: t('previousPeriod'), value: 'PREVIOUS_PERIOD' },
    // { label: t('monthBefore'), value: 'MONTH_BEFORE' },
    // { label: t('monthsBeforePlural', { count: 2 }), value: '2_MONTHS_BEFORE' },
    // { label: t('monthsBeforePlural', { count: 3 }), value: '3_MONTHS_BEFORE' },
    // { label: t('monthsBeforePlural', { count: 6 }), value: '6_MONTHS_BEFORE' },
    // { label: t('yearBefore'), value: 'YEAR_BEFORE' },
    { label: t('customPeriod'), value: 'CUSTOM' },
  ], [t]);

  const calculateComparisonRange = useCallback(
    (period: string): Date[] | null => {
      if (!referenceStartDate || !referenceEndDate) return null;

      let compStartDate: Date;
      let compEndDate: Date;

      switch (period as ComparisonPeriodType) {
        case 'PREVIOUS_PERIOD': {
          // Same length period immediately before
          const periodLengthInDays = differenceInDays(referenceEndDate, referenceStartDate);
          compEndDate = subDays(referenceStartDate, 1);
          compStartDate = subDays(compEndDate, periodLengthInDays);
          break;
        }
        // case 'MONTH_BEFORE': {
        //   compStartDate = subDays(referenceStartDate, 30);
        //   compEndDate = subDays(referenceEndDate, 30);
        //   break;
        // }
        // case '2_MONTHS_BEFORE': {
        //   compStartDate = subDays(referenceStartDate, 60);
        //   compEndDate = subDays(referenceEndDate, 60);
        //   break;
        // }
        // case '3_MONTHS_BEFORE': {
        //   compStartDate = subDays(referenceStartDate, 90);
        //   compEndDate = subDays(referenceEndDate, 90);
        //   break;
        // }
        // case '6_MONTHS_BEFORE': {
        //   compStartDate = subDays(referenceStartDate, 180);
        //   compEndDate = subDays(referenceEndDate, 180);
        //   break;
        // }
        // case 'YEAR_BEFORE': {
        //   compStartDate = subYears(referenceStartDate, 1);
        //   compEndDate = subYears(referenceEndDate, 1);
        //   break;
        // }
        case 'CUSTOM':
          return null;
        default:
          return null;
      }

      return [compStartDate, compEndDate];
    },
    [referenceStartDate, referenceEndDate]
  );

  return (
    <div className="comparison-date-range-picker">
      <span className="comparison-date-range-picker__label">{t('compareWith')}:</span>
      <DateRangePicker
        value={value}
        onChange={onChange}
        selectedPeriod={selectedPeriod}
        onPeriodChange={(period) => setSelectedPeriod(period as ComparisonPeriodType)}
        minDate={minDate}
        maxDate={maxDate}
        periodOptions={comparisonPeriodOptions}
        calculateRange={calculateComparisonRange}
        defaultPeriod="PREVIOUS_PERIOD"
      />
    </div>
  );
};

export default ComparisonDateRangePicker;
